export enum UserRole {
  Admin = "Admin",
  BackofficeAdmin = "BOAdmin",
  Backoffice = "Backoffice",
  Regulierer = "Regulierer",
  Interessent = "InteressentInnen",
}

export enum KundenterminStatus {
  Vereinbart = "Vereinbart",
  SpaeterVNNichtErreicht = "SpaeterVNNichtErrecith",
  NichtMoeglichPostweg = "NichtMoeglichPostweg",
  GeraetAufPostweg = "GeraetAufPostweg",
  PoststueckEingelangt = "PoststueckEingelangt",
  SpaeterMoeglich = "SpaeterMoeglich",
}

export enum TerminRueckfrageAnStatus {
  Abgeschlossen = "Abgeschlossen",
  WeitereRecherche = "WeitereRecherche",
  UeberBOVersendet = "UeberBOVersendet",
}

export enum TerminBerichtUrgentStatus {
  RueckstellungKurzinfo = "RueckstellungKurzinfo",
  Verzoegerungsinfo = "Verzoegerungsinfo",
}

export enum AktSparte {
  Mobil = "Mobil",
  Technik = "Technik",
  Diverse = "Diverse",
}

export enum AktOrtArt {
  Schadenort = "Schadenort",
  Besichtigung = "Besichtigung",
  Sonstiger = "Sonstiger",
}

export enum TextbausteinPlatzhalter {
  Besichtigungstermin = "{Besichtigungstermin}",
  KundenprozessLink = "{KundenprozessLink}",
  Rueckstellung = "{Rückstellung}",
}

export enum MailmanagerAction {
  ASSIGN = "ASSIGN",
  PRIVATE = "PRIVATE",
  INTERN = "INTERN",
  TRASH = "TRASH",
}

export enum AktOrtDetailKategorie {
  NichtDefiniert = "Nicht definiert",
  WeisseWare = "Weiße Ware",
  BrauneWare = "Braune Ware",
  ComputerEdv = "Computer, EDV",
  SchwarzeWareKleinelektro = "Schwarze Ware, Kleinelektro",
  Telekommunikation = "Telekommunikation",
  Elektroanlagen = "Elektroanlagen",
  Heizungsanlagen = "Heizungsanlagen",
  Sonstige = "Sonstige",
  TechnischeAnlagenHaushalt = "technische Anlagen Haushalt",
  GewerbegeräteUndKleingewerbeanlagen = "Gewerbegeräte und Kleingewerbeanlagen",
  AutomatisierungstechnikHaushalt = "Automatisierungstechnik Haushalt",
  Alarmanlagen = "Alarmanlagen",
  EnergiegewinnungSolar = "Energiegewinnung / Solar",
  Photovoltaikanlagen = "Photovoltaikanlagen",
  Beleuchtungsanlagen = "Beleuchtungsanlagen",
  Schwimmbadtechnik = "Schwimmbadtechnik",
  Klimaanlagen = "Klimaanlagen",
  Medizintechnik = "Medizintechnik",
  Gastrotechnik = "Gastrotechnik",
  Industrieanlagen = "Industrieanlagen",
  LandwirtschaftlicheAnlagen = "landwirtschaftliche Anlagen",
  Verkehrstechnik = "Verkehrstechnik",
  KfzTechnik = "KFZ-Technik",
}

export enum JaNeinUndefiniertOption {
  KeineDefinition = "Keine Definition",
  Ja = "Ja",
  Nein = "Nein",
}

export enum RechnungKausal {
  KeineDefinition = "Keine Definition",
  Ja = "Ja",
  Nein = "Nein",
  Teilweise = "Teilweise",
}

export enum TerminWorkflowProcess {
  VNUrgenz = "VNUrgenz",
  UrgenzAN = "UrgenzAN",
  RueckfrageAn = "Rückfr AN",
  RueckfrageVu = "Rückfr VU",
  QCDurchfuehrung = "QC durchfü",
  Kundentermin = "Kundenterm",
  BerichtUrgent = "Bericht ur",
  AbloeseAng = "Ablöse ang",
  BerichtVE = "Bericht ve",
}

export enum AbwesenheitTyp {
  Urlaub = "Urlaub",
  BerichtUrgenz = "BerichtUrgenz",
  Kundentermin = "Kundentermin",
}

export enum ZeitabrechnungAufwand {
  Berichtserstellung = "Berichtserstellung",
  Besichtigung = "Besichtigung",
  Fahrt = "Fahrt (anteilig)",
  Korrespondenz = "Korrespondenz",
  Recherche = "Recherche",
  Rechnungspruefung = "Rechnungsprüfung",
  Telefonat = "Telefonate",
  UnterlagenSichten = "Unterlagen sichten",
}

export enum KalkulationsArt {
  Gebaeude = "Gebaude",
  Inhalt = "Inhalt",
  PositionsKategorie1 = "PosKategorie1",
  PositionsKategorie2 = "PosKategorie2",
  PositionsKategorie3 = "PosKategorie3",
  PositionsKategorie4 = "PosKategorie4",
  PositionsKategorie5 = "PosKategorie5",
}

export enum GutachtenPositionsArt {
  Unbekannt = "Unbekannt",
  Wiederbeschaffungswert = "Wiederbeschaffungswert",
  Reparatur = "Reparatur",
}

export enum GutachtenAbloesevorschlag {
  KeineAngabe = "Kein Text",
  Besprochen = "Besprochen / VU entscheidet",
  VereinbartUnterfertigt = "Vereinbart / ist unterfertigt / liegt bei",
  VereinbartNachgereicht = "Vereinbart / wird nachgereicht",
  WiederherstellungDruchFirma = "Wünscht Wiederherstellung durch Firma",
}

export enum GutachtenKalkulationAbrechnungsArt {
  Neuwert = "Neuwert",
  Zeitwert = "Zeitwert",
}

export enum SchadenaufstellungEintragNachweis {
  Nein = "Nein",
  Rechnung = "Rechnung",
  Foto = "Foto",
  Sonstiges = "Sonstiges",
}

export enum EmpfaengerGruppe {
  to = "An",
  cc = "Cc",
  bcc = "Bcc",
}
